import { useContext } from 'react';
import { AccordionRegistryContext } from './accordion-registry-provider';

/**
 * Custom hook to access the accordion registry.
 * 
 * @returns {Object} - { register, unregister, getRegistry }
 */
const useAccordionRegistry = () => useContext(AccordionRegistryContext);

export default useAccordionRegistry;